var _g, _defs;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgMenuBids(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 21,
    viewBox: "0 0 22 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4744_98088)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.54312 6.13335L11 10.4469L18.4569 6.13335M11 19.0484V10.4384M18.6875 13.855V7.02169C18.6872 6.72211 18.6081 6.42788 18.4582 6.16851C18.3083 5.90915 18.0928 5.69377 17.8333 5.54398L11.8542 2.12731C11.5945 1.97737 11.2999 1.89844 11 1.89844C10.7001 1.89844 10.4055 1.97737 10.1458 2.12731L4.16667 5.54398C3.90722 5.69377 3.69173 5.90915 3.54181 6.16851C3.39189 6.42788 3.31281 6.72211 3.3125 7.02169V13.855C3.31281 14.1546 3.39189 14.4488 3.54181 14.7082C3.69173 14.9676 3.90722 15.1829 4.16667 15.3327L10.1458 18.7494C10.4055 18.8993 10.7001 18.9783 11 18.9783C11.2999 18.9783 11.5945 18.8993 11.8542 18.7494L17.8333 15.3327C18.0928 15.1829 18.3083 14.9676 18.4582 14.7082C18.6081 14.4488 18.6872 14.1546 18.6875 13.855Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4744_98088"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20.5,
    height: 20.5,
    fill: "white",
    transform: "translate(0.75 0.1875)"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuBids);
export default __webpack_public_path__ + "static/media/menu-bids.a027a33d996f78a5291983354d184b88.svg";
export { ForwardRef as ReactComponent };